// extracted by mini-css-extract-plugin
export default {"zoomModal":"Z2-z"};